<div class="simple-form-aligner">
  <mat-card *ngIf="state === 'emailSent'" class="simple-form-card">
    <form [formGroup]="codeForm" (ngSubmit)="formPostConfirmEmailCode()">
      <fieldset>
        <mat-card-content>
          <a [href]="this.homepageLinks.home">
            <div class="register-logo" role="img" alt="Logo"></div>
          </a>
          <h1>Email sent!</h1>

          <p>We sent an email to {{ email }}</p>
          <p>
            Click on the link in the email or copy the code into the field
            below.
          </p>

          <div class="form-group">
            <mat-form-field class="simple-form-field-100">
              <mat-label>Confirm email code</mat-label>
              <input
                matInput
                type="text"
                placeholder="Confirm email code"
                name="code"
                formControlName="code"
                required
              />
              <mat-error>
                Not a valid code. Check the link and try again.
              </mat-error>
            </mat-form-field>

            <br />

            <div class="button-right-container">
              <div></div>
              <div>
                <div class="spinner-container" *ngIf="waiting">
                  <mat-spinner diameter="24"></mat-spinner>
                </div>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="codeFormDisableSubmit"
                  type="submit"
                  value="submit"
                >
                  Confirm
                </button>
              </div>
            </div>
            <span *ngIf="codeFormErrorMessage" class="text-error-color">
              {{ codeFormErrorMessage }}
            </span>
          </div>

          <section style="color: red" *ngIf="confirmEmailCodeLink">
            WARNING: This confirm email code should not be visible in
            production:<br />
            <a href="{{ confirmEmailCodeLink }}">{{ confirmEmailCodeLink }}</a>
          </section>
        </mat-card-content>
      </fieldset>
    </form>
  </mat-card>

  <mat-card *ngIf="state === 'accountExistsLogIn'" class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>
      <h1>Account already exists</h1>
      <p>An account with this email already exists.</p>

      <a routerLink="/login">
        <button mat-raised-button color="primary">Click here to log in</button>
      </a>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="state === 'emailConfirmedLogIn'" class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>
      <h1>Email successfully confirmed</h1>
      <p>Your email was confirmed. Log in to start using Fociva.</p>

      <a routerLink="/login">
        <button mat-raised-button color="primary">Click here to log in</button>
      </a>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="state === 'linkExpiredRegister'" class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>
      <h1>Link expired</h1>
      <p>Please register again.</p>
      <a routerLink="/register">
        <button mat-raised-button color="primary">
          Click here to register
        </button>
      </a>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="state === 'checkingCode'" class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>
      <h1>Checking code</h1>
      <mat-spinner></mat-spinner>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="state === 'linkError'" class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>
      <h1>Link error</h1>
      <p>There was a problem with the provided link.</p>
      <a routerLink="/register">
        <button mat-raised-button color="primary">
          Click here to register
        </button>
      </a>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="state === 'unknownError'" class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>
      <h1>Error</h1>
      <p>There was an unknown error.</p>
      <p>If you continue to have this problem, please contact support.</p>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="state === 'loading'" class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>
      <h1>Loading</h1>
      <mat-spinner></mat-spinner>
    </mat-card-content>
  </mat-card>
</div>
